// this is the entry point of the whole react app - it's the first file that runs
// grab react itself so we can use jsx and components
import React from 'react';
// react-dom is the bit that actually sticks react onto a real webpage
import ReactDOM from 'react-dom/client';
// this handles all the page routing (which url shows which page) without full reloads
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// global styles for the whole site live here
import './index.css';
// pull in every page component so we can wire them up to urls below
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardPage from './pages/DashboardPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';

// find the empty <div id="root"> in index.html and tell react "this is your home"
const root = ReactDOM.createRoot(document.getElementById('root'));
// now actually draw the app inside that root
root.render(
  // strictmode is a dev-only helper that warns us about sketchy code, no effect in prod
  <React.StrictMode>
    {/* browserrouter watches the url and swaps pages in and out for us */}
    <BrowserRouter>
      {/* routes is basically a switch statement - only one route below matches at a time */}
      <Routes>
        {/* homepage / marketing page at the root url */}
        <Route path="/" element={<LandingPage />} />
        {/* sign in + sign up page. /signin?mode=signup opens it on the sign-up tab */}
        <Route path="/signin" element={<AuthPage />} />
        {/* password reset - both halves of it, the request and the new password */}
        <Route path="/forgot" element={<ForgotPasswordPage />} />
        {/* the logged-in area where you see your plan and upgrade */}
        <Route path="/dashboard" element={<DashboardPage />} />
        {/* the legal pages, nothing fancy */}
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* anything else gets a real 404 page rather than a silent bounce to the
            homepage. public/_redirects (and vercel.json, while vercel is still
            up) only rewrites the routes listed above, so a
            typo'd url is normally caught at the edge and never reaches react at
            all - this is the safety net for links clicked inside the app, which
            never hit the server. */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
